// @flow
/* eslint-disable no-template-curly-in-string */

export default {
  All: 'Semua',
  AllDocuments: 'Semua dokumen',
  Any: 'Setiap',
  Today: 'Hari ini',
  Yesterday: 'Kemarin',
  LastWeek: 'Minggu lalu',
  LastMonth: 'Bulan lalu',
  DateFrom: 'Dari',
  DateTo: 'Ke',
  DateRange: 'Rentang tanggal',
  NeverViewed: 'Tidak pernah dilihat atau diubah sejak terakhir dilihat',
  AddedLastLogin: 'Ditambahkan atau diubah sejak login terakhir',
  GlobalNetworkErrorMessage:
    'Ada masalah dengan jaringan. Coba lagi atau hubungi dukungan.',
  GlobalIntermediateProxyErrorMessage:
    'Jaringan Anda mencegat permintaan ini ke ruang data. Hubungi departemen TI Anda.',
  GlobalUnexpectedErrorWithIdMessage:
    'Ada masalah dengan ruang data Anda. Kutip kode ini \u003c[ErrorId]\u003eke tim Layanan Klien kami.',
  GlobalUnexpectedErrorMessage:
    'Ada masalah dengan ruang data Anda. Silakan hubungi tim Layanan Klien kami.',
  NoRecordsFound: 'Tidak ada catatan yang ditemukan.',
  Save: 'Menyimpan',
  Print: 'Mencetak',
  ViewAs: 'Lihat sebagai',
  Documents: 'Dokumen',
  Date: 'Tanggal',
  HideEmptyFolders: 'Sembunyikan folder kosong',
  Search: 'Mencari',
  Actions: 'Tindakan',
  Filter: 'Menyaring',
  Self: 'Anda',
  Allowed: 'Diizinkan',
  Denied: 'Ditolak',
  PleaseEnterValidToDate: 'Harap masukkan tanggal yang valid.',
  PleaseEnterValidFromDate: 'Harap masukkan tanggal mulai yang valid.',
  SavingAllowed: 'Menyimpan diperbolehkan',
  SavingDenied: 'Penyimpanan ditolak',
  PrintingAllowed: 'Pencetakan diizinkan',
  PrintingDenied: 'Pencetakan ditolak',
  ChooseLanguage: 'Pilih Bahasa',
  EditProfile: 'Edit Profil',
  DataRooms: 'Ruang Data',
  Administration: 'Administrasi',
  MyAccount: 'Akun Saya',
  Profile: 'Profil',
  Logout: 'Keluar',
  Loading: 'Memuat',
  Success: 'Kesuksesan',
  Disabled: 'Dengan disabilitas',
  Ok: 'Oke',
  And: 'Dan',
  Demo: 'demonstrasi',
  TenderSubmissionsStart: 'Mulai proses pengiriman',
  TenderSubmissionsOverdue:
    'Proses pengiriman telah berakhir. Dokumen yang Anda unggah sekarang akan ditandai sebagai terlambat.',
  TenderSubmissionsClose: 'Proses pengiriman telah berakhir.',
  Later: 'Nanti',
  StartNow: 'Mulai sekarang',
  StartSubmissionDialogTitle: 'Mulai proses pengiriman',
  StartSubmissionDialogContent:
    'Bidders will be notified that they can upload and view documents. ' +
    "Your internal teams can't access documents during the submission process.",
  StartSubmissionDialogCloseDateContent:
    'Proses pengiriman berakhir pada ${closeDate}.',
  SubmissionInformationIsIncomplete: 'Informasi pengiriman tidak lengkap. ',
  BidderTeamsHaveNotBeenInvitedOrHaveBeenRemoved:
    'Penawar tidak diundang atau telah dikeluarkan. ',
  InviteBidderTeams: 'Undang penawar',
  UpdateSecuritySettings: 'Perbarui pengaturan keamanan',
  UpdateTheirSecuritySettings: 'Perbarui pengaturan keamanan mereka.',
  OnTimeSubmission: 'Penyerahan tepat waktu',
  LateSubmission: 'Penyerahan terlambat',
  DeleteAllDocuments: 'Hapus semua dokumen pengiriman',
  Manage: 'Mengelola',
  ManageSubmissions: 'Kelola kiriman',
  NotStarted: 'Belum Dimulai',
  Closed: 'Tertutup',
  ExtraTime: 'Di Waktu Tambahan',
  Open: 'Membuka',
  CreateTheStructureAndSetTheCloseDateForBidderSubmissions:
    'Buat struktur dan tetapkan tanggal penutupan untuk penyerahan penawaran.',
  AddSubmissionWindow: 'Tambahkan jendela pengiriman',
  BiddersDoNotHaveAccessToAddSubmissionsSingular:
    '1 penawar tidak memiliki akses untuk menambahkan pengajuan.',
  BiddersDoNotHaveAccessToAddSubmissionsPlural:
    'Penawar ${totalBidders} tidak memiliki akses untuk menambahkan pengajuan.',
  BulkRedactionCurrentDocumentNumberOfTotal:
    '${currentDocumentNumber} dari ${totalDocsCount} dokumen',
  BulkRedactionMarksToRedact: '${selectedMarksCount} item yang akan disunting',
  BulkRedactionMarksRedacted: '${redactionMarksCount} item dihapus',
  BulkRedactionSkipAndNext: 'Lewati dokumen',
  BulkRedactionSkipAndFinish: 'Lewati dan selesaikan penyuntingan',
  BulkRedactionSaveAndNext: 'Simpan & dokumen berikutnya',
  BulkRedactionSaveAndFinish: 'Simpan dan selesaikan penyuntingan',
  BulkRedactionRedactAllRemainingDocuments:
    'Redact semua dokumen ${documentsRemaining}',
  BulkRedactionCancel: 'Membatalkan',
};
